// Action Types
export const VM_GET_RATES = "VM_GET_RATES";
export const VM_SET_RATES = "VM_SET_RATES";

// Action Creators

export const getRates = (query, cb = () => {}) => ({
  type: VM_GET_RATES,
  query,
  cb,
});

export const setRates = (data = { result: [], count: 0 }) => ({
  type: VM_SET_RATES,
  payload: data,
});
